import React from 'react';
import { ButtonCtaDto } from "../Models/ButtonCtaDto"

export default ({buttonCta, children} : {buttonCta?: ButtonCtaDto, children?: React.ReactNode}) => {
    if(!buttonCta) {
        return null;
    }
    const Tag = buttonCta.ctaHeaderTag as keyof JSX.IntrinsicElements;
    return (
        <div className="card w-100 mb-2">
            <div className="card-body flex-grow-1">
                {buttonCta.ctaHeader && buttonCta.ctaHeader.length > 0 &&<Tag className="card-title">
                    {buttonCta.ctaHeader}
                </Tag>}
                { buttonCta.ctaDescription && buttonCta.ctaDescription.length > 0 && <p className="card-text" dangerouslySetInnerHTML={{__html: buttonCta.ctaDescription}}></p> }

                {buttonCta.ctaButtons && buttonCta.ctaButtons.length > 0 && <div className='d-flex flex-wrap gap-2 mb-1'>
                    {buttonCta.ctaButtons.map((button, index) => (
                            <a key={button.url} className="btn btn-success mr-1" href={button.url} target={button.target || "_self"} rel="noopener noreferrer">
                                {button.name}
                            </a>
                    ))}
                </div>}
                {children}
            </div>
        </div>
    )
}
